import * as React from 'react';

// Icons
import { plus } from '@ibinder/common-icons';

// Styles
import {
  ActionbarContent,
  StyledToolButton,
  ExtraSpace
} from 'Shared/components/composite/ActionBarMenu/actionBar.styles';
import { Actionbar } from '@ibinder/common-frontend';

const IssueTemplateActionbar = ({ onAddTemplateItem }) => {
  return (
    <Actionbar>
      <ActionbarContent>
        <StyledToolButton type="button" onClick={onAddTemplateItem}>
          {plus}
          <ExtraSpace>Add field</ExtraSpace>
        </StyledToolButton>
      </ActionbarContent>
    </Actionbar>
  );
};

export default IssueTemplateActionbar;
